// Completely disable Push Notification Service
class PushNotificationService {
  constructor() {
    this.isSupported = false;
    this.permission = 'denied';
    this.settingsKey = 'push-notifications-enabled';
    this.isEnabled = false;
    this.serviceWorkerRegistration = null;
    this.notificationQueue = [];
  }

  // Initialize service worker - disabled
  async initServiceWorker() {
    // Do nothing - push notifications are disabled
    return Promise.resolve();
  }

  // Get current settings state
  getSettingsState() {
    return false; // Always return false - push notifications are disabled
  }

  // Update settings and auto-request permission if enabled
  updateSettingsState(enabled) {
    // Do nothing - push notifications are disabled
  }

  // Check if supported
  isNotificationSupported() {
    return false; // Never supported
  }

  // Get permission status
  getPermissionStatus() {
    return 'denied'; // Always denied
  }

  // Auto-request permission when enabled
  async autoRequestPermission() {
    return Promise.resolve(false); // Never grant permission
  }

  // Show notification that works in background
  showNotification(title, options = {}) {
    return null; // Never show notifications
  }

  // Show typed notification with enhanced features
  showTypedNotification(notification) {
    return null; // Never show notifications
  }

  // Handle notification clicks intelligently
  handleNotificationClick(notification) {
    // Do nothing - notifications are disabled
  }

  // Show notification even when tab is not focused
  showBackgroundNotification(title, options = {}) {
    return null; // Never show notifications
  }

  // Get status for UI
  getStatus() {
    return {
      isSupported: false,
      isEnabled: false,
      permission: 'denied',
      canShow: false,
      hasServiceWorker: false,
      serviceWorkerState: 'none'
    };
  }

  // Check if notifications should be shown
  shouldShowNotifications() {
    return false; // Never show notifications
  }

  // Request permission explicitly
  async requestPermission() {
    return Promise.resolve(false); // Never grant permission
  }
}

export default PushNotificationService;